import * as React from 'react'
import { IMobilityOptionCategoryObject, IMobilityOptionObject } from '../../types/index'
import Modal from '../ui/Modal'
import AddMobilityOptionCreateForm from './AddMobilityOptionCreateForm/AddMobilityOptionCreateForm'

export interface IMobilityOptionsAddOptionModalProps {
  onClose: () => void
  onCreateClick: (mobilityOption: IMobilityOptionObject) => Promise<any>
  categories: IMobilityOptionCategoryObject[]
}

interface IMobilityOptionsAddOptionModalState {
  isPending: boolean
  error: string
  newOption: string
}

class MobilityOptionsAddOptionModal extends React.Component<
  IMobilityOptionsAddOptionModalProps,
  IMobilityOptionsAddOptionModalState
> {
  constructor(props: IMobilityOptionsAddOptionModalProps) {
    super(props)
  }

  public render() {
    const { categories } = this.props

    const currentCategories: any[] = []
    Object.keys(categories).map((item, i) => {
      const v = categories[item].name
      currentCategories.push({ label: v, value: v })
    })

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-3 p2'>
            <span className='MobilityOptionsModalAddTitle font-small weight-300 font-grey2'>ADD MOBILITY DEVICE</span>
            <AddMobilityOptionCreateForm
              categories={currentCategories}
              onCancelClick={this.handleCancelClick}
              onCreateClick={this.props.onCreateClick}
            />
          </div>
        </div>
      </Modal>
    )
  }

  private handleCancelClick = () => {
    this.props.onClose()
  }
}

export default MobilityOptionsAddOptionModal



// WEBPACK FOOTER //
// ./src/components/mobility-options/MobilityOptionsAddOptionModal.tsx